const types = {
	//Get Template name
	GET_SUGGESTION_START: "GET_SUGGESTION_START",
	GET_SUGGESTION_SUCCESS: "GET_SUGGESTION_SUCCESS",
	GET_SUGGESTION_ERROR: "GET_SUGGESTION_ERROR",
	GET_SUGGESTION_RESET: "GET_SUGGESTION_RESET",

	//Create Template name
	CREATE_SUGGESTION_START: "CREATE_SUGGESTION_START",
	CREATE_SUGGESTION_SUCCESS: "CREATE_SUGGESTION_SUCCESS",
	CREATE_SUGGESTION_ERROR: "CREATE_SUGGESTION_ERROR",
	CREATE_SUGGESTION_RESET: "CREATE_SUGGESTION_RESET",

	//delete Template name
	DELETE_SUGGESTION_START: "DELETE_SUGGESTION_START",
	DELETE_SUGGESTION_SUCCESS: "DELETE_SUGGESTION_SUCCESS",
	DELETE_SUGGESTION_ERROR: "DELETE_SUGGESTION_ERROR",
	DELETE_SUGGESTION_RESET: "DELETE_SUGGESTION_RESET",

	//update Template name
	UPDATE_SUGGESTION_START: "UPDATE_SUGGESTION_START",
	UPDATE_SUGGESTION_SUCCESS: "UPDATE_SUGGESTION_SUCCESS",
	UPDATE_SUGGESTION_ERROR: "UPDATE_SUGGESTION_ERROR",
	UPDATE_SUGGESTION_RESET: "UPDATE_SUGGESTION_RESET",

	//single item  name
	SINGLE_SUGGESTION_START: "SINGLE_SUGGESTION_START",
	SINGLE_SUGGESTION_SUCCESS: "SINGLE_SUGGESTION_SUCCESS",
	SINGLE_SUGGESTION_ERROR: "SINGLE_SUGGESTION_ERROR",
	SINGLE_SUGGESTION_RESET: "SINGLE_SUGGESTION_RESET",
};

export default types;
